const REASON_TEXT = {
    engineer_clash: 'Already booked on another schedule',
    leave_clash: 'Engineer on approved leave',
    duplicate: 'Already assigned this day',
    outside_date_range: 'Outside the schedule date range',
    invalid_time_range: 'Start time must be earlier than end time',
};

function formatRange(start, end) {
    if (start && end) return `${start}-${end}`;
    if (start) return `from ${start}`;
    if (end) return `until ${end}`;
    return '';
}

export function formatRejectionReason(rec) {
    if (!rec) return 'Rejected';
    const reason = typeof rec === 'string' ? rec : rec.reason;
    if (!reason) return 'Rejected';

    if (typeof rec === 'object' && reason === 'engineer_clash') {
        const conflict = formatRange(rec.conflict_start_time, rec.conflict_end_time);
        const attempted = formatRange(rec.attempted_start_time, rec.attempted_end_time);
        if (conflict && attempted) {
            return `Already booked ${conflict} (clashes with your ${attempted})`;
        }
        if (conflict) {
            return `Already booked ${conflict} on another schedule`;
        }
        return REASON_TEXT.engineer_clash;
    }

    return REASON_TEXT[reason] || String(reason).replace(/_/g, ' ');
}

export function engineerNameFromAssignments(engineerId, assignments) {
    if (!engineerId) return '';
    if (!Array.isArray(assignments)) return engineerId;
    const match = assignments.find(a => a && a.engineer_id === engineerId && a.engineer_name);
    if (match && match.engineer_name) {
        const trimmed = String(match.engineer_name).trim();
        if (trimmed) return trimmed;
    }
    return engineerId;
}

export function buildAssignmentResult(scheduleId, apiResult, sourceAssignments) {
    if (!apiResult) return null;
    const created = Array.isArray(apiResult.created) ? apiResult.created : [];
    const rawRejected = Array.isArray(apiResult.rejected) ? apiResult.rejected : [];
    const rejected = rawRejected.map(r => ({
        ...r,
        engineer_name: engineerNameFromAssignments(r && r.engineer_id, sourceAssignments),
    }));
    return { scheduleId: scheduleId || null, created, rejected };
}
